<template>
  <div class="container" :class="{ selected }" @click="onClick">
    <div class="title-container">
      <span class="title">{{ emailTitle }}</span>
      <span class="new-dot" v-if="!read"></span>
    </div>
    <div class="preview">{{ emailContent }}</div>
    <div class="tag-container" v-if="tag">
      <div class="tag" :style="{ 'background-color': getTagColor(tag) }">{{ tag }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmailSidebarItem",
  props: {
    selected: Boolean,
    read: Boolean,
    tag: String,
    emailId: String,
    emailTitle: String,
    emailContent: String,
  },
  methods: {
    onClick() {
      this.$emit("click", this.emailId);
    },
    getTagColor(tag) {
      if (tag === "Aireo") return "#000";
      else if (tag === "Update") return "#3ba56c";
      else if (tag === "Family") return "#005eff";
      else if (tag === "Spam") return "#ca2929";
      return "#673AB7";
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables";

.container {
  box-sizing: border-box;
  padding: 8px;

  width: 100%;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.315);

  border-bottom: 1px solid grey;

  user-select: none;

  &.selected {
    background-color: #ddd;
  }

  .title-container {
    width: 100%;

    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 1.2em;
      color: $primary-text-black;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .new-dot {
      align-self: flex-start;

      width: 0.6em;
      height: 0.6em;

      border-radius: 0.3em;
      background-color: lightskyblue;
    }
  }

  .preview {
    color: $secondary-text-black;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .tag-container {
    margin-top: 8px;

    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    .tag {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      margin-left: 8px;

      width: 68px;
      height: 26px;

      border-radius: 99999px;
    }
  }
}
</style>
